import AppContext from "PFApp/app_context";
import Gantt from "PFApp/components/gantt/gantt";
import { useRoleJobCode } from "PFApp/use_role_job_code";
import PropTypes from "prop-types";
import React, { useContext } from "react";

import { AvailabilityInfoPanel } from "./availability_info_panel";
import { ProfileLabel } from "./profile_label";

const CompareAvailabilityPage = ({
  comparableProfiles,
  startDate,
  changeStartDate,
  availabilityInfo,
  removeProfileId,
  isBlindModeOn
}) => {
  const { currentAccount } = useContext(AppContext).store;
  const jobCodeDisplayAs = useRoleJobCode();

  let monthsLimit;
  try {
    monthsLimit = currentAccount.availability.calculated_months_limit;
  } catch (event) {
    monthsLimit = 6;
  }

  return (
    <Gantt
      monthsLimit={monthsLimit}
      rowItems={comparableProfiles}
      startDate={startDate}
      changeStartDate={changeStartDate}
      availabilityInfo={availabilityInfo}
      removeProfileId={removeProfileId}
      infoPanel={<AvailabilityInfoPanel availability={availabilityInfo} />}
      rowItemLabelComponent={(shortlist) => (
        <ProfileLabel
          key={shortlist.id}
          shortlist={shortlist}
          removeProfileId={removeProfileId}
          isBlindModeOn={isBlindModeOn}
        />
      )}
      jobCodeDisplayAs={jobCodeDisplayAs}
    />
  );
};

CompareAvailabilityPage.propTypes = {
  comparableProfiles: PropTypes.arrayOf(PropTypes.shape({ profile: PropTypes.object })).isRequired,
  startDate: PropTypes.instanceOf(Date).isRequired,
  changeStartDate: PropTypes.func.isRequired,
  availabilityInfo: PropTypes.object.isRequired, // see AvailabilityInfoPanel for details
  removeProfileId: PropTypes.func.isRequired,
  isBlindModeOn: PropTypes.bool
};

export default CompareAvailabilityPage;
